import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Loading from "../components/common/Loading/Loading.js";
import { STOCKHIDE_SUGGESTION_BOX_US_LINK } from "../../constants/links.js";

const SuggestionBox = () => {
    const navigate = useNavigate();


    useEffect(() => {
        // "noopener" makes App Bridge ask the Shopify admin to open the tab, so the popup blocker doesn't stop it
        window.open(STOCKHIDE_SUGGESTION_BOX_US_LINK, "_blank", "noopener");
        // Go home rather than back: the side menu can load this page fresh, leaving no page to go back to
        navigate("/", { replace: true });
    }, []);

    return (
        <Loading />
    );
};

export default SuggestionBox;